<template>
  <base-modal-center
    :isFooter="true"
    :onClose="sendSurvey"
    ref="onboardingModal"
    title="Compartilhe seu site"
    style="overflow: scroll; padding: 16px; overflow-x: hidden; flex-wrap: wrap"
  >
    <template #btn-close-icon>
      <i class="icon" style="margin-right: 10px">
        <base-icon name="painel/close-icon" />
      </i>
    </template>
    <div class="modal-share-wedsite has-text-centered">
      <h6 class="onboarding-title">Como funciona a sua lista de presentes</h6>
      <div class="onboard-row">
        <div class="onboard-column">
          <img class="onboard-step-img" width="72" :src="presenteImg" />
          <img class="onboard-number-step" width="37" :src="stepOne" />
        </div>
        <div class="onboard-column">
          Seus convidados compram os <b>presentes fictícios</b>
          direto no site de vocês.
        </div>

        <div class="onboard-column">
          <img class="onboard-step-img" width="72" :src="carteiraImg" />
          <img class="onboard-number-step" width="37" :src="stepTwo" />
        </div>
        <div class="onboard-column">
          Em <b>3 dias</b> vocês recebem tudo em <b>dinheiro</b> na sua
          <b>Carteira do Casar.com.</b>
        </div>
      </div>
      <div class="onboard-row">
        <div class="onboarding-sub-label">
          Com o saldo na Carteira vocês podem:
        </div>
        <div class="onboarding-option-img-row">
          <img class="onboard-step-img" width="72" :src="contaImg" />
          <img style="width: 40px; height: 40px" :src="ouIcon" />
          <img class="onboard-step-img" width="72" :src="shoppingImg" />
        </div>
        <div class="onboarding-option-label-row">
          <div>
            <b>Transferir gratuitamente</b>
            para a conta bancária <b>via PIX</b>.
          </div>
          <div>Comprar produtos para a casa no <b>Shopping Casar.com.</b></div>
        </div>
        <div class="survey-row">
          <div v-if="!answer">
            <div><b>Essa explicação foi útil para você?</b> (opcional)</div>
            <div class="survey-row-buttons">
              <div
                class="survey-row-button"
                @click="answerSurvey('nao-e-util')"
              >
                <img width="auto" :src="likeDown" />Não
              </div>
              <div
                class="survey-row-button"
                @click="answerSurvey('sim-e-util')"
              >
                <img width="auto" :src="likeUp" />Sim
              </div>
            </div>
          </div>

          <div v-if="answer && !endModal" style="margin-bottom: 5px">
            <div>
              Para que possamos melhorar, poderia nos contar quais dúvidas você
              possui?
            </div>
            <div class="survey-input-border">
              <base-input
                v-on:input="user_feedback = $event"
                :value="user_feedback"
                :hasIcon="false"
                placeholder="Escreva aqui (opcional)"
              >
              </base-input>
            </div>
            <div class="finish-feedback">
              <button
                type="button"
                class="button is-primary send-survey-btn"
                @click="sendSurvey"
              >
                Enviar
              </button>
            </div>
          </div>

          <div v-if="answer && endModal">
            <div class="survey-row-button positive-survey">
              <img class="positive-survey-img" width="auto" :src="likeUp" />
              Agradecemos seu feedback ;)
            </div>
          </div>
        </div>
      </div>
    </div>
  </base-modal-center>
</template>

<script>
import { mapGetters } from 'vuex'
import BaseModalCenter from '@/components/BaseModalCenter.vue'
import BaseInput from '@/components/BaseInput.vue'

import carteiraImg from '@/assets/img/onboarding-carteira.png'
import contaImg from '@/assets/img/onboarding-conta-bancaria.png'
import presenteImg from '@/assets/img/onboarding-presente-convidado.png'
import shoppingImg from '@/assets/img/onboarding-shopping.png'

import stepOne from '@/assets/img/step-one-icon.png'
import stepTwo from '@/assets/img/step-two-icon.png'
import arrowDown from '@/assets/img/dotted-arrow-down-icon.png'

import ouIcon from '@/assets/img/ou-icon.png'

import likeUp from '@/assets/img/like-up.svg'
import likeDown from '@/assets/img/like-down.svg'

import GiftsApi from '@/lib/api/Gifts'
import Slugify from '@/lib/utils/Slugify'

export default {
  components: {
    BaseModalCenter,
    BaseInput,
  },

  data() {
    return {
      carteiraImg,
      contaImg,
      presenteImg,
      shoppingImg,
      stepOne,
      stepTwo,
      arrowDown,
      ouIcon,
      likeUp,
      likeDown,
      answer: '',
      user_feedback: '',
      endModal: false,
      surveyType: 'lista_modal_onboarding',
    }
  },

  computed: {
    ...mapGetters({
      logonToken: 'app/logonToken',
      wedId: 'app/getWedId',
    }),
    hasAlreadyAnswered() {
      return (
        JSON.parse(localStorage.getItem('shownModalOnboardingGifts')) ?? false
      )
    },
  },

  async mounted() {
    if (!this.hasAlreadyAnswered) {
      const shownToday = await this.getSurveyAnswered()
      if (!shownToday) {
        this.open()
      }
    }
  },

  methods: {
    open() {
      this.$refs.onboardingModal.open()
    },

    close(emitter) {
      this.$refs.onboardingModal.close(emitter)
    },

    answerSurvey(ans) {
      this.answer = ans

      if (ans === 'sim-e-util') {
        this.endModal = true
        this.sendSurvey()
      }
    },

    getSurveyAnswered() {
      const giftsApi = new GiftsApi(this.logonToken)
      return giftsApi
        .getGiftsUserSurveysByType(this.surveyType)
        .then((surveys) => {
          if (surveys.length) return true
          return false
        })
        .catch(() => false)
    },

    sendSurvey() {
      const feedbackSlug = Slugify(this.user_feedback)
      this.answer = feedbackSlug
        ? `${this.answer}-${feedbackSlug}`
        : this.answer

      const data = {
        tipo: this.surveyType,
        resposta: this.answer || 'visualizado',
      }

      const giftsApi = new GiftsApi(this.logonToken)
      giftsApi
        .saveGiftsListsSurvey(data)
        .then((response) => {
          if (response.data)
            localStorage.setItem('shownModalOnboardingGifts', true)
        })
        .catch((error) => console.error(error))

      setTimeout(() => {
        this.close('off')
      }, 2000)
    },
  },
}
</script>

<style lang="scss" scoped>
.c-base-modal__body {
  padding: 0px !important;
}

.modal-share-wedsite {
  max-width: 587px !important;
  padding-left: 10px !important;
  padding-right: 10px !important;
}

.onboard-row {
  display: grid;
}

.onboard-column {
  display: inline-block;
  padding-left: 115px;
  padding-right: 115px;
  padding-top: 16px;
}

.onboarding-title {
  color: $neutral;
  font-size: 20px;
  font-weight: 700;
  padding-right: 40px;
  padding-left: 40px;
}

.onboarding-sub-label {
  font-size: 18px;
  font-weight: 700;
  color: #3dafb0;
  padding-top: 16px;
}

.onboarding-option-img-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 70px;
  padding-left: 70px;
  margin-top: 15px;
}

.onboard-number-step {
  margin-left: -20px;
}

.onboarding-option-label-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 10px;
  gap: 90px;
}

.survey-row {
  font-size: 14px;
  margin-top: 30px;

  .survey-row-buttons {
    display: flex;
    justify-content: center;
    gap: 12px;
    margin-top: 16px;

    .survey-row-button {
      display: flex;
      gap: 8px;
      border: 1px solid rgba(180, 197, 214, 0.5);
      border-radius: 8px;
      padding: 8px 16px;
    }

    .survey-row-button:hover {
      background: $neutrallightest;
      cursor: pointer;
    }
  }
}

@media (min-height: 900px) {
  .modal-share-wedsite {
    margin-bottom: 25px !important;
    margin-top: 20px !important;
  }
}

@media (max-width: 670px) {
  .modal-share-wedsite {
    max-width: 587px !important;
    max-height: 976px !important;
    padding-left: 10px !important;
    padding-right: 10px !important;
  }

  .onboard-column {
    display: inline-block;
    padding-left: 32px;
    padding-right: 32px;
    padding-top: 16px;
  }

  .onboarding-option-img-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 25px !important;
    padding-left: 25px !important;
    margin-top: 15px;
  }

  .onboarding-option-label-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 10px;
    gap: 90px;
  }
}

.positive-survey-img {
  vertical-align: middle;
  padding-right: 8px;
}

.finish-feedback {
  display: flex;
  justify-content: center;
  margin: 16px auto 0;
}
</style>
